import { render, staticRenderFns } from "./detainmentDialog.vue?vue&type=template&id=2fad380b&scoped=true"
import script from "./detainmentDialog.vue?vue&type=script&lang=js"
export * from "./detainmentDialog.vue?vue&type=script&lang=js"
import style0 from "./detainmentDialog.vue?vue&type=style&index=0&id=2fad380b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fad380b",
  null
  
)

export default component.exports